<template>

  <div class="mt-2 mb-3">
    <div class="row">
      <div class="col-md-12 d-flex align-items-center">
        <span class="medium-text">{{ simulationConstruction.name }}</span>
        <trash-icon class="main-red-color trashIcon ml-2" size="16" @click="removeSimulationConstruction"/>
        <span v-if="isOperationLinked" class="ml-3 bold-text strongLink" @click="showAddPosteTravauxModal">
          <template v-if="!hasLinkedOperations">+ {{ $t('simulation.link.poste') }}</template>
          <div v-else class="d-flex align-items-center">
            <div v-for="(text, index) in linkedOperationsText" :key="index" class="d-flex align-items-center">
              <span class="mr-2">{{ text }}</span>
              <span class="text-success mr-3">✓</span>
            </div>
          </div>
        </span>
      </div>
    </div>

    <add-simulation-poste-travaux-modal
      ref="addSimulationPosteTravauxModal"
      :simulation-construction="simulationConstruction"
      :modal-id="'add-simulation-poste-travaux-modal-' + uniqueId"
      :operation-id="operationId"
      @didAddPosteTravaux="handleAddPosteTravaux">
    </add-simulation-poste-travaux-modal>

    <div class="row mt-2">

      <template v-if="simulationConstruction.uniteConstruction.value === 'M2'">

        <div class="col-md-4">
          <b-input-group>
            <b-form-input
              id="surface-input"
              v-model="simulationConstruction.surface"
              v-disable-scroll
              :placeholder="$t('simulationConstruction.Surface')"
              min="0"
              required
              step="any"
              type="number"
              v-on:change="emitChangeValue">
            </b-form-input>
            <b-input-group-append>m²</b-input-group-append>
          </b-input-group>
        </div>

        <div class="col-md-4">
          <b-input-group>
            <b-form-input
              id="prixParM2-input"
              v-model="simulationConstruction.prixParM2"
              v-disable-scroll
              :placeholder="$t('simulationConstruction.PrixParM2')"
              min="0"
              required
              step="any"
              type="number"
              v-on:change="emitChangeValue">
            </b-form-input>
            <b-input-group-append>{{ $t('euros.prixTTC') }}/m²</b-input-group-append>
          </b-input-group>
        </div>

        <div class="col-md-4">
          <div class="d-flex prixTTCContainer d-flex justify-content-between">
            <div>{{ $t('simulationConstruction.prixTTC') }}</div>
            <div class="prixTTC bold-text">{{ prixTTC }}€</div>
          </div>
        </div>

      </template>

      <template v-else>
        <div class="col-md-6">
          <b-input-group>
            <b-form-input
              id="prix-input"
              v-model="simulationConstruction.prixParM2"
              v-disable-scroll
              :placeholder="$t('simulationConstruction.prix')"
              min="0"
              required
              step="any"
              type="number"
              v-on:change="emitChangeValue">
            </b-form-input>
            <b-input-group-append>{{ $t('euros.prixTTC') }}</b-input-group-append>
          </b-input-group>
        </div>
      </template>

    </div>


  </div>

</template>

<script>
import AddSimulationPosteTravauxModal from './AddSimulationPosteTravauxModal.vue'
import api from '../../../services/api'

export default {

  name: "SimulationConstructionComponent",

  components: {
    AddSimulationPosteTravauxModal
  },

  props: {
    simulationConstruction: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      required: true
    },
    isOperationLinked: {
      type: Boolean,
      default: false
    },
    operationId: {
      type: Number,
      default: null
    }
  },

  computed: {
    uniqueId() {
      return `construction-${this.simulationConstruction.id}`
    },

    prixTTC() {
      return this.simulationConstruction.prixTTC ? this.simulationConstruction.prixTTC : (this.simulationConstruction.surface * this.simulationConstruction.prixParM2)
    },

    linkedOperationsText() {
      if (!this.hasLinkedOperations) return ''

      const countAVP = this.linkedOperationsAVP.length
      const countEXE = this.linkedOperationsEXE.length
      let text = []

      if (countAVP > 0) {
        if (countAVP === 1) {
          text.push(`${this.linkedOperationsAVP[0].name} (AVP)`)
        } else {
          text.push(`${countAVP} postes de travaux (AVP)`)
        }
      }

      if (countEXE > 0) {
        if (countEXE === 1) {
          text.push(`${this.linkedOperationsEXE[0].name} (EXE)`)
        } else {
          text.push(`${countEXE} postes de travaux (EXE)`)
        }
      }

      return text
    }
  },

  emits: ['removedSimulationConstruction', 'didChangeValue'],

  data() {
    return {
      hasLinkedOperations: false,
      linkedOperationsAVP: [],
      linkedOperationsEXE: []
    }
  },

  methods: {
    removeSimulationConstruction() {
      if (!this.simulationConstruction || !this.simulationConstruction.id) {
        console.error('Impossible de supprimer : construction invalide')
        return
      }

      api
        .post(`/simulationConstruction/deleteSimulation?id=${this.simulationConstruction.id}`)
        .then(() => {
          this.$emit('removedSimulationConstruction', this.simulationConstruction)
        })
        .catch(error => {
          console.error('Erreur lors de la suppression de la construction:', error)
          if (error.response) {
            if (error.response.status === 404) {
      this.$emit('removedSimulationConstruction', this.simulationConstruction)
            } else if (error.response.status === 401) {
              this.$router.push({
                name: 'SimulationIndex',
                params: {
                  message: error.response.data.message
                }
              })
            }
          }
        })
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    showAddPosteTravauxModal() {
      const modalId = 'add-simulation-poste-travaux-modal-' + this.uniqueId
      this.$bvModal.show(modalId)
      this.$refs.addSimulationPosteTravauxModal.show()
    },

    handleAddPosteTravaux() {
      this.loadLinkedOperations()
    },

    loadLinkedOperations() {
      if (this.operationId && this.simulationConstruction && this.simulationConstruction.id){
        api
          .get(`/simulationConstruction/getLinkedOperations?simulationConstructionId=${this.simulationConstruction.id}`)
          .then(response => {
            console.log('Constructions liées:', response.data)
            this.linkedOperationsAVP = response.data.constructionsAVP
              .filter(construction => construction.typeConstruction.value === this.simulationConstruction.typeConstruction.value)
            this.linkedOperationsEXE = response.data.constructionsEXE
              .filter(construction => construction.typeConstruction.value === this.simulationConstruction.typeConstruction.value)
            this.hasLinkedOperations = this.linkedOperationsAVP.length > 0 || this.linkedOperationsEXE.length > 0
          })
          .catch(error => {
            console.error('Erreur lors de la récupération des constructions liées:', error)
          })
      }
    }

  },

  watch: {
    simulationConstruction: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadLinkedOperations()
        }
      }
    }
  },

  mounted() {
    console.log('operationId (component) : ', this.operationId)
  }

}

</script>

<style scoped>

.prixTTCContainer {
  padding: 8px 12px;
  background-color: #F4F4F4;
  color: #CCCCCC;
  border: solid 1px #CCCCCC;
}

.prixTTC {
  color: var(--main-color);
}

</style>



// WEBPACK FOOTER //
// src/views/simulation/components/SimulationConstructionComponent.vue